<div class="custom-answer" [ngClass]="{'has-delete':showDelete}">
  <div class="custom-answer__title">
    <input
      type="text"
      placeholder="Describe activity"
      class="form-control"
      [name]="uniqueDescriptionControlName"
      [id]="uniqueDescriptionId"
      [(ngModel)]="description"
      (ngModelChange)="onChange()"
      >
    </div>


    <div class="custom-answer__percent">
      <input
        type="text"
        placeholder="0"
        class="form-control"
        [name]="uniqueValueControlName"
        [id]="uniqueValueId"
        [(ngModel)]="value"
        (ngModelChange)="onChange()"
        >
        <span class="custom-answer__percent-indi">%</span>
      </div>

      @if (showDelete) {
        <div class="custom-answer__delete">
          <a href="#" class="action-remove">
            <svg class="icon">
              <use xlink:href="#trash"></use>
            </svg>
          </a>
        </div>
      }
    </div>
